import client from './client';

export interface WebhookRecord {
  id: number;
  name: string;
  url: string;
  is_active: boolean;
  secret?: string;
}

export interface WebhookInput {
  name: string;
  url: string;
  is_active: boolean;
  secret?: string;
}

export const webhooksApi = {
  getAll: () => client.get<WebhookRecord[]>('/webhooks/'),
  getById: (id: number) => client.get<WebhookRecord>(`/webhooks/${id}`),
  create: (input: WebhookInput) => client.post<WebhookRecord>('/webhooks/', input),
  update: (id: number, input: WebhookInput) =>
    client.put<WebhookRecord>(`/webhooks/${id}`, { ...input, id }),
  delete: (id: number) => client.delete<{ success: boolean; message: string }>(`/webhooks/${id}`),
  validate: (id: number) => client.post<WebhookRecord>(`/webhooks/${id}/validate`),
};
